import React from 'react'
import BudgetActionRow from './BudgetActionRow'
import withView from '../../../cmn/docAutomation/withView';
import { UiView, UiViewHeading, UiTitle, UiAction, UiViewContent } from "../../../../library/layout/Index";

const BudgetAction = (props) => {
    const { formObject, viewData, onSelectTask, selectedTask } = props;

    const onRowClick = (rowKey) => {
        if(onSelectTask)onSelectTask(rowKey);
    }

    return (
        <>
            <UiView>
                <UiViewHeading>
                    <UiTitle>
                        <span className="uiInline"></span>
                    </UiTitle>
                    <UiAction>
                    </UiAction>
                </UiViewHeading>
                <UiViewContent>
                    <ul>
                    {
                        Object.values(viewData ? viewData : {}).map((row, index) => (
                            <BudgetActionRow formObject={formObject} rowKey={row.rowKey} viewData={row}
                            onRowClick={onRowClick} selectedTask={selectedTask}
                            />
                        ))
                    }
                    </ul>
                </UiViewContent>
            </UiView>
        </>
    )
}

export default withView(BudgetAction, "budgetAction", "");